const SRI_LANKA_TIME_ZONE = "Asia/Colombo";

const normalizeUtcValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value !== "string") return null;

  const text = value.trim();
  if (!text) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return null;

  const normalized = text.includes("T") ? text : text.replace(" ", "T");
  return new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized) ? normalized : `${normalized}Z`);
};

const formatUtcDateTime = (value, options = {}) => {
  const date = normalizeUtcValue(value);
  if (!date || Number.isNaN(date.getTime())) return "N/A";

  return new Intl.DateTimeFormat("en-LK", {
    timeZone: SRI_LANKA_TIME_ZONE,
    ...options,
  }).format(date);
};

export const formatUtcTimeInSriLanka = (value) => formatUtcDateTime(value, {
  hour: "2-digit",
  minute: "2-digit",
});

export const formatUtcDateTimeInSriLanka = (value) => formatUtcDateTime(value, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

export const formatCalendarDate = (value) => {
  if (!value) return "N/A";
  const text = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return String(value);

  const [year, month, day] = text.split("-");
  return `${day}/${month}/${year}`;
};
